import { useConfigLookup } from '@/hooks/useConfigLookup';
import { Badge } from '@/components/ui/badge';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

export interface ConfigLabelProps {
    categoryCode: string;
    value?: string | null;
    fallback?: string;
    className?: string;
}

export function ConfigLabel({ categoryCode, value, fallback, className }: ConfigLabelProps) {
    const { options, isLoading } = useConfigLookup(categoryCode);

    if (!value) return null;

    if (isLoading) {
        return <Skeleton className={cn("h-5 w-20", className)} />;
    }

    // Try to find by id (code) or label (text) in case of legacy data
    const item = options.find(
        (o) => o.id === value || o.label?.toLowerCase() === value.toLowerCase()
    );

    if (!item) {
        // Not found in master data, display fallback or raw value with warning style
        return (
            <Badge variant="outline" className={cn("text-[10px] font-medium bg-orange-50 text-orange-600 border-orange-200", className)}>
                {fallback || value}
            </Badge>
        );
    }

    // Display the mapped label with standard style
    return (
        <Badge variant="outline" className={cn("text-[10px] font-medium bg-slate-50 text-slate-600 border-slate-200", className)}>
            {item.label}
        </Badge>
    );
}
